module.exports = __webpack_public_path__ + "static/media/resume.84bbbf7c.pdf";